import $ from "jquery";
import {sendPostQuery} from "./helpers";

let notifications = [];

let loanIssuedPopupName = 'loanIssued'
let loanNotIssuedPopupName = 'loanNotIssued'
let repayCancelPopupName = 'repayCancel'
let repaySuccessPopupName = 'repaySuccess'
let loanCanceledPopupName = 'loanCanceled'
let mcWarningPopupName = 'mcWarning'
let marginCallPopupName = 'marginCall'
let unlockAccountPopupName = 'unlockAccount'
let updatesPopupName = 'updateConditions'
let depositRefill = 'drSuccess'

let unreadMessagesCount = 0;
let needReloadPage = false;

export const getNotifications = (needReload = false) => {
    if (needReload) {
        needReloadPage = true
    }
    $.ajax({
        url: '/not-show-popup',
        type: 'GET',
        data: {},
        success: function (result) {
            if (result) {
                if (!result.error) {
                    notificationProcessing(result);
                } else {
                    return false;
                }
            }
        }
    });

    return notifications
}

const getUnreadMessages = () => {
    $.ajax({
        type: 'GET',
        url: '/not-read-messages',
        data: {},
        success: function (result) {
            if (result) {
                unreadMessagesCount = result.count;
            }
        }
    });

    return notifications
}

const notificationProcessing = (notifications) => {
    if (Array.isArray(notifications)) {
        notifications.map(function (notification) {
            if (notification['popup'] && !notification['show']) {
                const popupName = notification['popup']
                displayPopup(popupName, notification['msg'], notification['data'])
            }
        });
    }
}

const displayPopup = (popupName, popupText, data) => {
    if (popupName === loanIssuedPopupName) {
        showLoanIssuedModal(popupText);
    }
    if (popupName === loanNotIssuedPopupName) {
        showLoanNotIssuedModal(popupText);
    }
    if (popupName === repayCancelPopupName) {
        showRepayCancel();
    }
    if (popupName === repaySuccessPopupName) {
        showRepaySuccess(popupText);
    }
    if (popupName === loanCanceledPopupName) {
        showLoanCanceledModal(popupText);
    }
    if (popupName === mcWarningPopupName) {
        showMcWarningModal(popupText);
    }
    if (popupName === marginCallPopupName) {
        marginCallModal(popupText);
    }
    if (popupName === unlockAccountPopupName) {
        unlockAccountModal(popupText);
    }
    if (popupName === updatesPopupName) {
        updatesModal(popupText);
    }
    if (popupName === depositRefill) {
        showDepositRefillModal(data);
    }
}

const showLoanIssuedModal = (popupText) => {
    $('#loan-issued-text').text(popupText)
    $('#loanIssued').modal('show');
}

const showLoanNotIssuedModal = () => {
    $('#loanNotIssued').modal('show');
}

const showLoanCanceledModal = () => {
    $('#loanCanceled').modal('show');
}

const showRepaySuccess = (popupText) => {
    $('#repay-success-text').text(popupText)
    $('#successLoanRepay').modal('show');
}

const showRepayCancel = () => {
    $('#cancelLoanRepay').modal('show');
}

const showDepositRefillModal = (data) => {
    const popupData = JSON.parse(data)
    $('#drs-data').text(popupData.join(' '))
    $('#drSuccess').modal('show');
}

const loanIssuedModalHidden = () => {
    $('#loanIssued').on('hidden.bs.modal', function (e) {
        notificationPopupQuery(loanIssuedPopupName)
    })
}

const depositRefillModalHidden = () => {
    $('#drSuccess').on('hidden.bs.modal', function (e) {
        notificationPopupQuery(depositRefill)
    })
}

const showMcWarningModal = (popupText) => {
    $('#mc-risk-text').text(popupText)
    $('#highRiskMarginCall').modal('show');
}

const marginCallModal = (popupText) => {
    $('#mc-text').text(popupText)
    $('#marginCall').modal('show');
}

const loanNotIssuedModalHidden = () => {
    $('#loanNotIssued').on('hidden.bs.modal', function (e) {
        notificationPopupQuery(loanNotIssuedPopupName)
    })
}

const successRepayModalHidden = () => {
    $('#successLoanRepay').on('hidden.bs.modal', function (e) {
        notificationPopupQuery(repaySuccessPopupName)
    })
}

const cancelRepayModalHidden = () => {
    $('#cancelLoanRepay').on('hidden.bs.modal', function (e) {
        notificationPopupQuery(repayCancelPopupName)
    })
}

const loanCanceledModalHidden = () => {
    $('#loanCanceled').on('hidden.bs.modal', function (e) {
        notificationPopupQuery(loanCanceledPopupName)
    })
}

const mcWarningModalHidden = () => {
    $('#highRiskMarginCall').on('hidden.bs.modal', function (e) {
        notificationPopupQuery(mcWarningPopupName)
    })
}

const marginCallModalHidden = () => {
    $('#marginCall').on('hidden.bs.modal', function (e) {
        notificationPopupQuery(marginCallPopupName)
    })
}

const unlockAccountModal = () => {
    $('#unlockAccount').modal('show')
}

const unlockAccountModalHidden = () => {
    $('#unlockAccount').on('hidden.bs.modal', function (e) {
        notificationPopupQuery(unlockAccountPopupName)
    })
}

function updatesModal() {
    $('#updatesModal').modal('show')
}

const updatesModalHidden = () => {
    $('#updatesModal').on('hidden.bs.modal', function (e) {
        notificationPopupQuery(updatesPopupName)
    })
}

export const markMessagesRead = () => {
    const url = '/notifications-mark-read';
    sendPostQuery(url, false, false);
}

const notificationPopupQuery = (popupName) => {
    const url = '/notification-popup-show';
    const data = {
        'popupName': popupName,
    };

    sendPostQuery(url, needReloadPage, false, data);
}

const configureNotification = (hourIdentifier, rateIdentifier) => {
    const ltvPercent = $('#' + rateIdentifier).text()
    const hour = $('#' + hourIdentifier).text()

    let data = {
        'percent': ltvPercent,
        'hour': hour,
    }
    sendPostQuery('/user-settings', true, true, data, false, '');
}

const changeRangeValue = (value) => {
    $('#mc-ltv-percent').val(value)
    $('#mc-percent').text(value)
    $('#mc-percent-sm').text(value)
}

const increaseHour = (identifier) => {
    const element = $('#' + identifier)
    let hour = parseInt(element.text());
    if (hour < 24) {
        hour = hour + 1;
        setHourVal(identifier, hour)
    }
}

const setHourVal = (element, value) => {
    $('#' + element).text(value)
}

const decreaseHour = (identifier) => {
    const element = $('#' + identifier)
    let hour = parseInt(element.text())
    if (hour > 1) {
        hour = hour - 1;
        setHourVal(identifier, hour)
    }
}

const showSmSettingBlock = () => {
    const dNone = 'd-none'
    const smSettingBlock = $('#sm-setting-block')
    smSettingBlock.removeClass(dNone)
    $('#show-sm-setting-block').addClass(dNone)
    $('#hide-sm-setting-block').removeClass(dNone)
}


const hideSmSettingBlock = () => {
    const dNone = 'd-none'
    const smSettingBlock = $('#sm-setting-block')
    smSettingBlock.addClass(dNone)
    $('#show-sm-setting-block').removeClass(dNone)
    $('#hide-sm-setting-block').addClass(dNone)
}

$(document).ready(() => {
    if (window.location.pathname === '/instant' || window.location.pathname === '/notifications'
            || window.location.pathname === '/deposits') {
        getNotifications();
        loanIssuedModalHidden();
        loanNotIssuedModalHidden();
        successRepayModalHidden();
        cancelRepayModalHidden();
        loanCanceledModalHidden();
        mcWarningModalHidden();
        marginCallModalHidden();
        getUnreadMessages();
        unlockAccountModalHidden();
        updatesModalHidden();
        depositRefillModalHidden();
        setInterval(function () {
            getNotifications();
            getUnreadMessages();
        }, 60 * 2 * 1000);
        if (window.location.pathname === '/notifications') {
            setTimeout(function () {
                if (unreadMessagesCount > 0) {
                    markMessagesRead();
                }
            }, 5 * 1000);
        }
    }
})

window.configureNotification = configureNotification;
window.changeRangeValue = changeRangeValue;
window.increaseHour = increaseHour;
window.decreaseHour = decreaseHour;
window.showSmSettingBlock = showSmSettingBlock;
window.hideSmSettingBlock = hideSmSettingBlock;
